import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import CloseIcon from '@mui/icons-material/Close'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import GetAppIcon from '@mui/icons-material/GetApp'
import {
  Alert,
  AppBar,
  Backdrop,
  Badge,
  BadgeProps,
  Box,
  Card,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Fab,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Snackbar,
  styled,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { Dispatch } from '@reduxjs/toolkit'
import { toFarsiDigits } from 'farsi-digits'
import _ from 'lodash'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'

import ABS from '../../assests/icons/abs.png'
import ACU from '../../assests/icons/acu.png'
import BCM from '../../assests/icons/bcm.png'
import Ecu from '../../assests/icons/ecu.png'
import * as routes from '../../config/constants'
import { IsServiceItem } from '../../interfaces/IsServiceItem'
import Button from '../../shared/Button'
import CardErrorEngine from '../../shared/CardErrorEngine'
import ServiceItemContainerErrors from '../../shared/ServiceItemContainerErrors'
import {
  getLastTrouble,
  getLastTrouble1,
  getLoading,
  getPaginatedTrouble,
  getTroubleCodeClear1,
  getTroubleCodeRead,
  getTroubleLast,
  getTroubleLast1,
  resetLastTrouble,
  resetTroubleCode,
  troubleCodeClear,
  troubleCodeClear1,
  troubleCodeRead,
} from '../../store/devices'
interface Props {
  items: IsServiceItem[]
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />
})
const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    backgroundColor: 'red',
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))
const ErrorEngineScreen = () => {
  const loading = useSelector(getLoading)

  const [flag, setFlag] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [open1, setOpen1] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)
  const [open3, setOpen3] = React.useState(false)
  const [open4, setOpen4] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
    setFlag(true)
  }

  const handleCloseOpen4 = () => {
    setOpen4(false)
  }
  const handleClose = () => {
    setOpen(false)
    dispatch(resetLastTrouble)
    dispatch(resetTroubleCode)

    setFlag(false)
  }
  const handleClickOpen1 = () => {
    setOpen1(true)
    setFlag(true)
  }

  const handleClose1 = () => {
    setOpen1(false)
    dispatch(resetLastTrouble)
    dispatch(resetTroubleCode)
    setFlag(false)
  }
  const handleClickOpen2 = () => {
    setOpen2(true)
    setFlag(true)
  }

  const handleClose2 = () => {
    setOpen2(false)
    dispatch(resetLastTrouble)
    dispatch(resetTroubleCode)
    setFlag(false)
  }
  const handleClickOpen3 = () => {
    setOpen3(true)
    setFlag(true)
  }

  const handleClose3 = () => {
    setOpen3(false)
    dispatch(resetLastTrouble)
    dispatch(resetTroubleCode)
    setFlag(false)
  }
  const { id } = useParams()
  const lastTrouble = useSelector(getTroubleLast)
  const troubleRead = useSelector(getTroubleCodeRead)
  const troubleClear1 = useSelector(getTroubleCodeClear1)
  useEffect(() => {
    if (troubleRead === undefined) return

    setOpen4(true)
  }, [troubleRead, troubleClear1])
  useEffect(() => {
    if (troubleClear1 === undefined) return
    setOpen4(true)
  }, [troubleClear1])
  const lastTrouble1 = useSelector(getTroubleLast1)

  useEffect(() => {
    dispatch(getLastTrouble1({ deviceId: id, unitType: 0 }))
  }, [flag])
  const Services: IsServiceItem[] = [
    {
      id: '1',
      disable: false,
      title: 'ECU',
      icon: (
        <StyledBadge
          badgeContent={lastTrouble1?.filter((p: any) => p.unitType === 'ECU').length}
          color='secondary'
        >
          <img src={Ecu} style={{ marginTop: 4 }} width='50px' />
        </StyledBadge>
      ),

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        dispatch(getLastTrouble({ deviceId: id, unitType: 1 }))
        handleClickOpen()
      },
    },
    {
      id: '2',
      disable: true,
      title: 'ABS',
      icon: (
        <StyledBadge
          badgeContent={lastTrouble1?.filter((p: any) => p.unitType === 'ABS').length}
          color='secondary'
        >
          <img src={ABS} style={{ marginTop: 4 }} width='50px' />
        </StyledBadge>
      ),

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        // dispatch(getLastTrouble({ deviceId: id, unitType: 2 }))
        // handleClickOpen1()
      },
    },
    {
      id: '3',
      disable: true,
      title: 'ACU',
      icon: (
        <StyledBadge
          badgeContent={lastTrouble1?.filter((p: any) => p.unitType === 'ACU').length}
          color='secondary'
        >
          <img src={ACU} style={{ marginTop: 4 }} width='50px' />
        </StyledBadge>
      ),

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        // dispatch(getLastTrouble({ deviceId: id, unitType: 3 }))
        // handleClickOpen2()
      },
    },
    {
      id: '4',
      disable: true,
      title: 'BCM',
      icon: (
        <StyledBadge
          badgeContent={lastTrouble1?.filter((p: any) => p.unitType === 'BCM').length}
          color='secondary'
        >
          <img src={BCM} style={{ marginTop: 4 }} width='50px' />
        </StyledBadge>
      ),

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        // dispatch(getLastTrouble({ deviceId: id, unitType: 4 }))
        // handleClickOpen3()
      },
    },
  ]
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()
  const action = (
    <React.Fragment>
      <IconButton aria-label='close' color='inherit' onClick={handleCloseOpen4} size='small'>
        <CloseIcon fontSize='small' />
      </IconButton>
    </React.Fragment>
  )
  const location = useLocation()

  const dispatch = useDispatch<Dispatch<any>>()
  const navigate = useNavigate()

  // useEffect(() => {
  //   if (lastTrouble?.length === 0) return
  //   // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  //   enqueueSnackbar(` تعداد خطاها     ${toFarsiDigits(lastTrouble?.length)} خطا می باشد `, {
  //     variant: 'success',
  //   })
  // }, [lastTrouble?.length !== 0])
  useEffect(() => {
    return () => {
      dispatch(resetLastTrouble)
    }
  }, [])
  const handleHistory = () => {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    navigate(`/${routes.HISTORY_ERRORS}/${id}`)
  }
  const handleClearError = () => {
    dispatch(troubleCodeClear({ imei: id }))
  }
  // useEffect(() => {
  //   dispatch(getLastTrouble({ deviceId: location.state.location.state.id }))
  // }, [])
  // تابع تبدیل تاریخ شمسی به میلادی
  const shamsi = (time: any) => {
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('HH:mm:ss YYYY/MM/DD')
  }
  return (
    <Container fixed maxWidth='sm'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '85vh',
          direction: 'ltr',
        }}
      >
        <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
          <ArrowBackRoundedIcon
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: 'red',
              borderRadius: '50%',
              color: '#fff',

              cursor: 'pointer',
            }}
          />
          <img alt='Logo' src='/images/TinyLogo.png' />
        </Box>
        <Backdrop
          open={loading}
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000000000000000 }}
        >
          <CircularProgress color='inherit' />
        </Backdrop>
        <Box sx={{ mt: 4, mb: 1 }} width='100%'>
          <Button fullWidth onClick={handleHistory} sx={{ mb: 1 }} variant='contained'>
            {t('screens.ErrorEngineScreen.history_errors')}
          </Button>
          {/* <Button fullWidth onClick={handleClearError} variant='contained'>
            پاک کردن خطاها
          </Button> */}
        </Box>
        <ServiceItemContainerErrors items={Services} />

        <div>
          <Dialog
            fullScreen
            onClose={handleClose}
            open={open}
            sx={{ zIndex: '1000000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>

            <Snackbar
              action={action}
              autoHideDuration={3000}
              message='اطلاعات جهت اعمال تغییرات ثبت شد'
              onClose={handleCloseOpen4}
              open={open4}
            >
              <Alert
                onClose={handleCloseOpen4}
                severity='info'
                sx={{ width: '100%', background: 'green' }}
              >
                اطلاعات جهت اعمال تغییرات ثبت شد
              </Alert>
            </Snackbar>

            <AppBar sx={{ position: 'sticky', direction: 'ltr' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose}>
                  <CloseIcon />
                </IconButton>

                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeClear1({ imei: id, unitType: 1 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <DeleteForeverIcon />
                </Fab>

                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeRead({ imei: id, unitType: 1 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <GetAppIcon />
                </Fab>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  ECU خطاهای مربوط به
                </Typography>
              </Toolbar>
            </AppBar>
            {lastTrouble.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {lastTrouble?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
        <div>
          <Dialog
            fullScreen
            onClose={handleClose1}
            open={open1}
            sx={{ zIndex: '10000000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>
            <Snackbar
              action={action}
              autoHideDuration={3000}
              message='اطلاعات جهت اعمال تغییرات ثبت شد'
              onClose={handleCloseOpen4}
              open={open4}
            >
              <Alert
                onClose={handleCloseOpen4}
                severity='info'
                sx={{ width: '100%', background: 'green' }}
              >
                اطلاعات جهت اعمال تغییرات ثبت شد
              </Alert>
            </Snackbar>
            <AppBar sx={{ position: 'sticky', direction: 'ltr' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose1}>
                  <CloseIcon />
                </IconButton>
                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeRead({ imei: id, unitType: 2 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <DeleteForeverIcon />
                </Fab>
                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeRead({ imei: id, unitType: 2 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <GetAppIcon />
                </Fab>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  ABS خطاهای مربوط به
                </Typography>
              </Toolbar>
            </AppBar>
            {lastTrouble.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {lastTrouble?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
        <div>
          <Dialog
            fullScreen
            onClose={handleClose2}
            open={open2}
            sx={{ zIndex: '10000000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>
            <Snackbar
              action={action}
              autoHideDuration={3000}
              message='اطلاعات جهت اعمال تغییرات ثبت شد'
              onClose={handleCloseOpen4}
              open={open4}
            >
              <Alert
                onClose={handleCloseOpen4}
                severity='info'
                sx={{ width: '100%', background: 'green' }}
              >
                اطلاعات جهت اعمال تغییرات ثبت شد
              </Alert>
            </Snackbar>
            <AppBar sx={{ position: 'sticky', direction: 'ltr' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose2}>
                  <CloseIcon />
                </IconButton>
                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeRead({ imei: id, unitType: 3 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <DeleteForeverIcon />
                </Fab>
                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeRead({ imei: id, unitType: 3 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <GetAppIcon />
                </Fab>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  ACU خطاهای مربوط به
                </Typography>
              </Toolbar>
            </AppBar>
            {lastTrouble.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {lastTrouble?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
        <div>
          <Dialog
            fullScreen
            onClose={handleClose3}
            open={open3}
            sx={{ zIndex: '10000000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>
            <Snackbar
              action={action}
              autoHideDuration={3000}
              message='اطلاعات جهت اعمال تغییرات ثبت شد'
              onClose={handleCloseOpen4}
              open={open4}
            >
              <Alert
                onClose={handleCloseOpen4}
                severity='info'
                sx={{ width: '100%', background: 'green' }}
              >
                اطلاعات جهت اعمال تغییرات ثبت شد
              </Alert>
            </Snackbar>
            <AppBar sx={{ position: 'sticky', direction: 'ltr' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose3}>
                  <CloseIcon />
                </IconButton>
                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeRead({ imei: id, unitType: 4 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <DeleteForeverIcon />
                </Fab>
                <Fab
                  aria-label='add'
                  color='info'
                  onClick={() => {
                    dispatch(troubleCodeRead({ imei: id, unitType: 4 }))
                  }}
                  size='medium'
                  sx={{ m: 1, p: 0 }}
                  variant='extended'
                >
                  <GetAppIcon />
                </Fab>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  BCM خطاهای مربوط به
                </Typography>
              </Toolbar>
            </AppBar>
            {lastTrouble.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {lastTrouble?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
      </Box>
    </Container>
  )
}

export default ErrorEngineScreen
